export default {"src":"/_next/static/media/residential6.432fc400.svg","height":73,"width":72,"blurWidth":0,"blurHeight":0};